import { userIdentifier } from '@nutrien/ddc-fe-authentication-react-legacy';
import {
  createApplicationIdentifier,
  knockIdentifier,
  screenIdentifier,
} from '@nutrien/ddc-fe-logging-pwa';
import {
  correlationIdentifier,
  deviceIdentifier,
  Identifier,
} from '@nutrien/ddc-fe-logging-react-router-dom';

import { application } from './application';

export const applicationIdentifier = createApplicationIdentifier(application);

export const identifiers: Identifier<unknown>[] = [
  applicationIdentifier,
  correlationIdentifier,
  deviceIdentifier,
  knockIdentifier,
  screenIdentifier,
  userIdentifier,
] as Identifier<unknown>[];
